import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Router from './routes';
import { setTokenData } from './store/authReducer';
import { getTokenData } from './utils';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const tokenData = getTokenData();
    if (tokenData) dispatch(setTokenData(tokenData));
  }, []);

  return <Router />;
}

export default App;
